/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = BODYSHOP
 *
 * 1 = INTERNAL
 *
 * 2 = MOT
 *
 * 3 = RECOVERY
 *
 * 4 = SCHEDULED_MAINTENANCE
 *
 * 5 = SERVICE
 *
 * 6 = UNSCHEDULED_MAINTENANCE
 *
 * 7 = WARRANTY
 */
export enum RepairOrderJobServiceType {
  BODYSHOP = 0,
  INTERNAL = 1,
  MOT = 2,
  RECOVERY = 3,
  SCHEDULED_MAINTENANCE = 4,
  SERVICE = 5,
  UNSCHEDULED_MAINTENANCE = 6,
  WARRANTY = 7,
}
